import { GET_SETTLEMENT_REPORT } from "../types/reportType";
import {
    GET_SETTLEMENT_TRANSACTION_BATCHES,
    GET_SETTLEMENT_TRANSACTION
} from "../types/settlementType";

const initialState = {
    settlementData: [],
    transactionBatches: [],
    settlementTransactions: [],
    totalElements: null,
    size: 25,
    number: 0
};

//this is not in use
const settlementReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_SETTLEMENT_REPORT:
            return {
                ...state,
                settlementData: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        case GET_SETTLEMENT_TRANSACTION_BATCHES:
            return {
                ...state,
                transactionBatches: payload
            };
        case GET_SETTLEMENT_TRANSACTION:
            return {
                ...state,
                settlementTransactions: payload
            };
        default:
            return state;
    }
};

export default settlementReducer;
